import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgArrowBack = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.5, strokeLinecap: "round", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M13 20l-3 -8l3 -8", strokeLinecap: "round", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgArrowBack);
export default ForwardRef;
